import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// third-party
// fonts
import 'assets/fonts/inter/inter.css';

// scroll bar
import 'simplebar/dist/simplebar.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// apex-chart
import 'assets/third-party/apex-chart.css';
import 'assets/third-party/react-table.css';

import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persister } from 'store';
import { ConfigProvider } from 'contexts/ConfigContext';
import { APP_BASE_NAME } from 'config';
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://b3bc5f1febfb175e0c1b575d46bd0e6f@o278481.ingest.us.sentry.io/4510579348471808",
  integrations: [Sentry.browserTracingIntegration()],
   tracesSampleRate: 1.0,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
   tracePropagationTargets: ["localhost", /^https:\/\/newlooksystem\.com/],
});


const container = document.getElementById('root');
const root = createRoot(container!);



// Wrap with Sentry.ErrorBoundary only in production
const AppComponent = (
  <ReduxProvider store={store}>
    <PersistGate loading={null} persistor={persister}>
      <ConfigProvider>
        <BrowserRouter basename={APP_BASE_NAME}>
          <App />
        </BrowserRouter>
      </ConfigProvider>
    </PersistGate>
  </ReduxProvider>
);



root.render(
  process.env.REACT_APP_ENV==='development' ? (AppComponent ):
  (<Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
    {AppComponent}
  </Sentry.ErrorBoundary>)
);


 // <ReduxProvider store={store}>
  //    <PersistGate loading={null} persistor={persister}>
  //     <ConfigProvider>
  //       <BrowserRouter basename={APP_BASE_NAME}>
  //         <App />
  //       </BrowserRouter>
  //   </ConfigProvider>
  // </PersistGate>
  // </ReduxProvider>
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
